export default __webpack_public_path__ + "static/per-marker-customisation-f71d78131aac8b832b093b2e075d2d97.png";